module.exports = __webpack_public_path__ + "lato-bold-webfont.59f2878fceb72400b482.eot";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/layout/fonts/lato-bold-webfont.eot
// module id = ../../../../../resources/layout/fonts/lato-bold-webfont.eot
// module chunks = styles